import { observer } from 'mobx-react-lite'
import { match } from '@/utils/pattern-match-util'
import { WorkspaceSignup } from '@/features/iam/workspaces/WorkspaceSignup'
import { MemberSignupViewContainer } from '@/features/iam/workspaces/components/MemberSignupView/MemberSignupViewContainer'
import { WorkspaceSearchViewContainer } from '@/features/iam/workspaces/components/WorkspaceSearchView/WorkspaceSearchViewContainer'
import { type WorkspaceSignupViewModel } from './WorkspaceSignupViewModel'

export interface WorkspaceSignupContainerProps {
  vm: WorkspaceSignupViewModel
}

export const WorkspaceSignupContainer = observer(
  function WorkspaceSignupContainer({ vm }: WorkspaceSignupContainerProps) {
    return (
      <WorkspaceSignup
        configurerView={vm.configurerView}
        onBack={vm.closeWorkspaceSearch}
      >
        {match(vm.configurerView, {
          Search: () => <WorkspaceSearchViewContainer vm={vm} />,
          Register: () => <MemberSignupViewContainer vm={vm} />,
        })}
      </WorkspaceSignup>
    )
  },
)
